import defaultActions from './default';
import { getStationsUsersGroupsByUser } from '../api/hdrainClient';

const ENTITIES = 'STATIONS_USERS_GROUPS';
const ENTITY = 'STATIONS_USERS_GROUP';
const Entity = 'StationsUsersGroup';
const entityName = 'stationsUsersGroup';
const ENTITIES_COLLECTION = 'stationsUsersGroups';

const fetchCollectionByStandardUser = getStationsUsersGroupsByUser;
const entityActions = defaultActions({
  ENTITIES,
  ENTITY,
  Entity,
  entityName,
  ENTITIES_COLLECTION,
  fetchCollectionByStandardUser,
});
export const { ACTIONS_NAMES_DICT } = entityActions;

export const { ENTITY_ACTIONS } = entityActions;
export const { fetchEntities } = entityActions;

export const { createEntity } = entityActions;

export const { updateEntity } = entityActions;
export const { archiveEntity } = entityActions;
export const { entitiesCleanUp } = entityActions;
export const { clearEntitiesDataLogout } = entityActions;
